module.exports = __webpack_public_path__ + "static/media/3.8af1b636.jpg";